import { app } from '../../../../app';
import { Controller } from './approvals.controller';

app.component('approvals', {
    bindings: {
        approvals: '<',
    },
    controller: Controller,
    templateUrl: require('./approvals.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/request-center/approvals/approvals.component.js